import React from "react";
import styles from "./styles.module.css";
import "../../commonStyle.css";
import HeadLines from "../HeadLines";
import { useHistory } from "react-router";
import { isMobile } from "../../helperFunc";

const MediaCoverageCard = (props) => {
  const {
    className = "",
    imageClassName = "",
    detailsClassName = "",
    headingClassName = "",
    shortCard = true,
    showBlackStrip = true,
    blackStripText = "",
    headingText = "",
    subHeadingClassName = "",
    subHeadingText = "",
    imgSrc,
    pageUrl = "",
  } = props;
  let lang = localStorage.getItem("lang");
  // console.log("hgffgh");
  return (
    <div
      className={`
      boxRadius8
      positionRelative
      boxShadow15 cursor-pointer
      ${isMobile ? "" : " margin-bottom24 "}
    ${shortCard && styles["short-card"]}
    ${!shortCard && styles["long-card"]}
    ${className}`}
      onClick={() => {
        if (shortCard && pageUrl) window.location.href = pageUrl;
      }}
    >
      <div>
        <img
          className={`boxRadius8 ${shortCard && styles["short-card-image"]} 
          ${!shortCard && styles["long-card-image"]}
          ${imageClassName}`}
          src={imgSrc}
          alt=""
        />
      </div>
      <div
        className={`positionAbsolute width-100 borderRadiusBottom ${
          shortCard ? styles["mediaHeight"] : styles["mediaHeight2"]
        } ${styles["bottom0"]} bg-white`}
      >
        {showBlackStrip && blackStripText && (
          <HeadLines
            className={`positionAbsolute ${
              isMobile
                ? "font-size12 line-height14 letterSpacing025"
                : "font-size14 line-height16 letterSpacing05"
            } ${styles["black-strip"]}  `}
            text={blackStripText}
          ></HeadLines>
        )}
        <div
          className={`  padding-left12 
                        padding-right12 
                        padding-top12 
                        padding-bottom16 
                        borderRadiusBottom
                    ${detailsClassName}`}
        >
          <HeadLines
            className={` 
            ${styles["one-line-elipsis"]}
           
            ${
              isMobile
                ? "font-size14 line-height16 letterSpacing001"
                : "font-size18 line-height21 letterSpacing05"
            } ${styles["margin-bottom8"]} ${headingClassName}`}
            text={headingText}
          />
          <HeadLines
            className={`colorDark7 
            ${
              isMobile
                ? "font-size12 line-height14 letterSpacing025 "
                : "font-size14 line-height16 letterSpacing05"
            }
            
            ${
              shortCard &&
              `${
                isMobile
                  ? styles["three-line-elipsis"]
                  : styles["two-line-elipsis"]
              } ${lang !== "en" && styles["padding-top1"]}`
            }
            ${!shortCard && styles["two-line-elipsis"]}
            ${subHeadingClassName}`}
            text={subHeadingText}
          />
          {!shortCard && pageUrl && (
            <div
              className={`${styles["read-more"]} ${styles["text-accent3"]} cursor-pointer`}
              onClick={() => {
                window.location.href = pageUrl;
              }}
            >
              <span>Read More</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaCoverageCard;
